'use strict';
import Vivus from 'vivus';

/**
 * svg
 */
export const svg = (() => {
    let stroke = null;

    // const strokes = []

    /**
     * init
     */
    const init = () => {
        setStroke();
        $(window).on('scroll', function () {
            setTimeout(() => {
                startStroke();
            }, 100);
        });
    };

    const setStroke = () => {
        stroke = new Vivus('js-figure', {
            duration: 60, type: 'sync', start: 'manual', forceRender: false
        });
    }

    const drawStroke = () => {
        stroke.play();
    }

    const startStroke = () => {
        if ($('#js-figure').hasClass('is-inview')) {
            setTimeout(() => {
                drawStroke();
            }, 400);
        };
    }

    // public
    return {
        init: init
    };
})();